import {IRange} from "@pg-design/range-module";

interface IShownBounds {
    lower: number;
    upper: number;
}

/**
 * The slider reports both thumbs on every move. Only the thumb that actually moved becomes a value: the other bound
 * stays as the user left it, possibly empty, instead of being filled with the end of the slider.
 * Returns `null` when there is nothing to save: a partial or non-finite report, or no thumb moved.
 */
export const getHomeMatchAreaAfterSliderChange = (current: IRange<number>, shown: IShownBounds, reported: IRange<number>): IRange<number> | null => {
    const {lower, upper} = reported;

    if (typeof lower !== "number" || typeof upper !== "number" || !Number.isFinite(lower) || !Number.isFinite(upper)) return null;

    const lowerMoved = lower !== shown.lower;
    const upperMoved = upper !== shown.upper;

    if (!lowerMoved && !upperMoved) return null;

    return {lower: lowerMoved ? lower : current.lower, upper: upperMoved ? upper : current.upper};
};
import {IRange} from "@pg-design/range-module";

interface IShownBounds {
    lower: number;
    upper: number;
}

/**
 * The slider reports both thumbs on every move. Only the thumb that actually moved becomes a value: the other bound
 * stays as the user left it, possibly empty, instead of being filled with the end of the slider.
 * Returns `null` when there is nothing to save: a partial or non-finite report, or no thumb moved.
 */
export const getHomeMatchAreaAfterSliderChange = (current: IRange<number>, shown: IShownBounds, reported: IRange<number>): IRange<number> | null => {
    const {lower, upper} = reported;

    if (typeof lower !== "number" || typeof upper !== "number" || !Number.isFinite(lower) || !Number.isFinite(upper)) return null;

    const lowerMoved = lower !== shown.lower;
    const upperMoved = upper !== shown.upper;

    if (!lowerMoved && !upperMoved) return null;

    return {lower: lowerMoved ? lower : current.lower, upper: upperMoved ? upper : current.upper};
};
